function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Lunacy");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "logout"
}, React.createElement("path", {
  d: "M6 8.828L10.414 4.414L6 0L4.586 1.414L6.586 3.414L0 3.414L0 5.414L6.586 5.414L4.586 7.414L6 8.828Z",
  transform: "translate(4 3.585999)",
  id: "Path",
  stroke: "none"
}), React.createElement("path", {
  d: "M11 14L2 14L2 2L11 2L11 0L1 0C0.448 0 0 0.448 0 1L0 15C0 15.552 0.448 16 1 16L11 16L11 14Z",
  id: "Path",
  stroke: "none"
}));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.baeae49e.svg";
export { ForwardRef as ReactComponent };